import React, { useEffect } from 'react';
import "./globals.css";
import Footer from "./components/Footer";
import NavigationBar from "./components/NavigationBar";

const CallForAbstracts = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Abstracts";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <div className="page-abstracts">
        <div className="abstracts-section">
          <h1 className="abstracts-title">Call For Abstracts</h1>

          {/* <p className="abstracts-lead">
            The Call for Abstracts for IWPFI 2026 will open soon.
          </p> */}
        </div>
        <p className="abstracts-subtitle">
            The Call for Abstract is now closed.
        </p>

        {/* IMPORTANT DATES */}
        {/* <section className="abstracts-card">
          <h2 className="abstracts-subtitle">Important Dates</h2>

          <div className="abstracts-table-wrapper">
            <table className="abstracts-table" aria-label="Important Dates">
              <tbody>
                <tr>
                  <th scope="row">Conference Dates</th>
                  <td>September 23–25, 2026</td>
                </tr>
                <tr>
                  <th scope="row">Location</th>
                  <td>Mont-Tremblant, Quebec, Canada</td>
                </tr>
                <tr>
                  <th scope="row">Abstract Deadline</th>
                  <td>
                    <strong><s>April 3, 2026</s> — EXTENDED! May 1, 2026</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Notification of Acceptance & Young Investigator Award Finalists Announcement</th>
                  <td>
                    <strong>May 15, 2026</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Early Bird Registration</th>
                  <td>
                    <strong>May 29, 2026</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="abstracts-note">
            <strong>Late submissions will not be accepted.</strong>
          </p>
          <p className="abstracts-note">
            <strong>Young Investigator Awards</strong><br></br>
            A total of five abstracts will be selected as finalists for the Young Investigator Award and Presentations. 
            Each finalist will receive a $500 travel grant. Two prizes will be awarded: 2026 YOUNG INVESTIGATOR awardee 
            and the 2026 YI runner up prize for the top two presentations (CAD $500 and $250). Finalists will be notified by email.
          </p>
          <p className="abstracts-note">
            <strong>Oral and Poster Presentations</strong><br></br>
            Unless a submitter explicitly indicates on the submission form that they wish to present only as a poster, the authors of 
            the top 40 abstracts, including the 5 finalists for the Young Investigator Forum, will be selected for oral presentations. 
            All other accepted abstracts will have the opportunity to be presented as digital posters during one of the poster sessions.
          </p>

        </section> */}

        {/* ELIGIBILITY */}
        {/* <section className="abstracts-card">
          <h2 className="abstracts-subtitle">Eligibility</h2>

          <p className="abstracts-text">
            Abstracts must describe original, unpublished work (or work recently submitted within
            the last year) related to pulmonary functional imaging, including but not limited to:
          </p>

          <ul className="abstracts-list">
            <li>Methods development</li>
            <li>Imaging biomarkers</li>
            <li>Results in participants</li>
            <li>Clinical or preclinical studies</li>
            <li>Image analysis</li>
            <li>Simulations or innovations</li>
          </ul>

          <p className="abstracts-text">
            Each presenting author may submit up to <strong>two</strong> abstracts.
          </p>
        </section> */}

        {/* REVIEW */}
        {/* <section className="abstracts-card">
          <h2 className="abstracts-subtitle">Review and Notification</h2>
          <p className="abstracts-text">
            Abstracts will be peer reviewed and authors notified by email.
          </p>
        </section> */}

        {/* HOW TO SUBMIT */}
        {/* <section className="abstracts-card">
          <div className="abstracts-cta">
            <button type="button" className="reg-button abstracts-button">
              <a 
                href="https://conference.has.uwo.ca/Register/default.aspx?code=C002378" 
                target="_blank" 
                rel="noopener noreferrer"
                className="reg-button"
              >
                Submit an Abstract
              </a>
            </button> */}
            {/* <p className="abstracts-cta-note">
              Submission link will be added later this week.
            </p> */}
          {/* </div>
        </section> */}
        <div className="footer-logo">
          <img src="/images/iwpfi_horizontal_logo.jpg" alt="Logo" />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CallForAbstracts;

// const CallForAbstracts = () => {
//   return (
//     <div id="everything">
//       <NavigationBar />

//       <main className="page-abstracts">
//         <section className="abstracts-section">
//           <h1 className="abstracts-title">Call for Abstracts</h1>

//           <p className="abstracts-lead">
//             The Call for Abstracts for IWPFI 2026 will open soon.
//           </p>
//           <p>
//             To submit an abstract, you must first complete your registration for the conference. 
//             At the end of the registration form, you will be prompted to continue to the abstract 
//             submission process if you wish to submit an abstract for IWPFI 2026.
//           </p>
//         </section>
//       </main>

//       <Footer />
//     </div>
//   );
// };

// export default CallForAbstracts;
